import { useContext } from 'react';
import { useMutation } from 'react-query';
import { AuthContext } from '../../Context/AuthContext';

const createContactPerson = async ({ token, contactData }) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/vesselOwner/profile/upload/contactPerson`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(contactData),
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  return response.json();
};

export const useCreateContactPerson = () => {
  const { token } = useContext(AuthContext);

  return useMutation((contactData) => createContactPerson({ token, contactData }));
};